// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hJmB","colMin":"styles_colMin__1DDsF"};